import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const AppointmentSurvey = (_param)=> {
    var { className , labels , surveyUrl , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "surveyUrl",
        "onClick"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-survey', className)
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, labels.title), /*#__PURE__*/ React.createElement(Text, null, labels.description), /*#__PURE__*/ React.createElement(Button, {
        className: "appointment-survey__button",
        caption: labels.cta,
        href: surveyUrl,
        onClick: onClick,
        hrefTarget: "_blank"
    }));
};

export { AppointmentSurvey as default };
//# sourceMappingURL=AppointmentSurvey.js.map
